import getEspSubscriptionsByEspListId from 'ui-forms-editor-automation-lib/selectors/subscriptions/getEspSubscriptionsByEspListId';
export const CHANGE_SUBSCRIPTION_STATUS = '@@lib/CHANGE_SUBSCRIPTION_STATUS';
const changeSubcriptionEnabled = payload => ({
  type: CHANGE_SUBSCRIPTION_STATUS,
  payload
});
const updateEspCheckbox = espListId => (dispatch, getState) => {
  const subscriptionByEspListId = getEspSubscriptionsByEspListId(getState()).map(subscription => {
    if (subscription.espListId === espListId) {
      subscription.syncEnabled = !subscription.syncEnabled;
    }
    return subscription;
  });
  dispatch(changeSubcriptionEnabled(subscriptionByEspListId));
};
export default updateEspCheckbox;